export const VAULT_STATUS = {
  created: 'created',
  passcodeGenerated: 'passcode_generated',
  passcodeRegenrated: 'passcode_regenerated',
} as const;

export const NOT_CATEGORIZED_DOCUMENT = 'UNCATEGORIZED_DOCUMENT';
